import { Component, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, Input, HostListener, NgModule } from '@angular/core';
import { ResponsiveService, EventWrapperService, B2CSharedResponsiveModule, B2CSharedEventModule } from 'b2c-ui/core';
import { tap, map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';
import { HeaderBannerIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-subheader.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'b2c-ui-icon';

function B2CSubHeaderComponent_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c0 = function (a0) { return { "background-image": a0 }; };
function B2CSubHeaderComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵtemplate(2, B2CSubHeaderComponent_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(2, _c0, "url(" + ctx_r0.coverImage + ")"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function B2CSubHeaderComponent_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CSubHeaderComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, B2CSubHeaderComponent_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function B2CSubHeaderComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.title, " ");
} }
function B2CSubHeaderComponent_ng_template_5_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CSubHeaderComponent_ng_template_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CSubHeaderComponent_ng_template_5_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.customTemplate);
} }
const _c1 = function (a0) { return { "text-md": a0 }; };
function B2CSubHeaderComponent_ng_template_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "p", 12);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "h2", 13);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵelementStart(6, "p", 14);
    ɵngcc0.ɵɵprojection(7, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c1, ctx_r9.isMobile));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r9.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r9.isMobile ? "text-sm" : "text-md");
} }
const _c2 = function (a0) { return { "min-height": a0 }; };
function B2CSubHeaderComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtemplate(1, B2CSubHeaderComponent_ng_template_5_ng_container_1_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, B2CSubHeaderComponent_ng_template_5_div_2_Template, 8, 5, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c2, ctx_r5.isMobile ? "130px" : "190px"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.allowCustomTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.allowCustomTemplate);
} }
const _c3 = ["*", [["p"]]];
const _c4 = ["*", "p"];
class B2CSubHeaderComponent {
    /**
     * @param {?} responsiveService
     * @param {?} cdRef
     * @param {?} eventWrapper
     */
    constructor(responsiveService, cdRef, eventWrapper) {
        this.responsiveService = responsiveService;
        this.cdRef = cdRef;
        this.eventWrapper = eventWrapper;
        this.title = '';
        this.subtitle = '';
        this.scrollDistance = 0;
        this.allowCustomTemplate = false;
        this.isMobile = false;
        this.scrolled = false;
        this.showSticky = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.subscription = this.responsiveService
            .isMobileWeb()
            .pipe(tap((/**
         * @param {?} isMobileWeb
         * @return {?}
         */
        (isMobileWeb) => (this.isMobile = isMobileWeb))))
            .subscribe();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.scrolled = window.scrollY > this.scrollDistance;
        this.scrollSubscription = this.eventWrapper.scrollEvent
            .pipe(map((/**
         * @return {?}
         */
        () => window.scrollY)), map((/**
         * @param {?} scrollPos
         * @return {?}
         */
        (scrollPos) => scrollPos > this.scrollDistance)), tap((/**
         * @param {?} scrolled
         * @return {?}
         */
        (scrolled) => {
            /** @type {?} */
            const showSticky = this.checkOriginalViewport();
            if (this.scrolled !== scrolled || this.showSticky !== showSticky) {
                this.scrolled = scrolled;
                this.showSticky = showSticky;
                this.cdRef.markForCheck();
            }
        })))
            .subscribe();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    }
    /**
     * @private
     * @return {?}
     */
    checkOriginalViewport() {
        /** @type {?} */
        const rect = document.getElementById('b2c-subheader-full').getBoundingClientRect();
        /** @type {?} */
        const visible = rect.top >= -rect.height &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
        // sticky should only shown when the header is gone.
        return !visible;
    }
}
B2CSubHeaderComponent.ɵfac = function B2CSubHeaderComponent_Factory(t) { return new (t || B2CSubHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.EventWrapperService)); };
B2CSubHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CSubHeaderComponent, selectors: [["b2c-subheader"]], hostBindings: function B2CSubHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function B2CSubHeaderComponent_resize_HostBindingHandler($event) { return ctx.ngOnInit($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { title: "title", subtitle: "subtitle", scrollDistance: "scrollDistance", allowCustomTemplate: "allowCustomTemplate", coverImage: "coverImage", customTemplate: "customTemplate" }, ngContentSelectors: _c4, decls: 7, vars: 3, consts: [[1, "b2c-subheader"], [4, "ngIf", "ngIfElse"], ["defaultBackgroundTemplate", ""], [4, "ngIf"], ["subheaderContentTemplate", ""], ["id", "b2c-subheader-full", 1, "bg", 3, "ngStyle"], [4, "ngTemplateOutlet"], ["b2c-ui-icon", "", "name", "headerBannerIcon", "id", "b2c-subheader-full", 1, "bg"], [1, "w-100", "text-xs", "text-black", "fixed-top", "text-center", "font-weight-bold", "pt-1", "pb-1", "shadow-sm", "bg-white", 2, "z-index", "100"], [1, "b2c-subheader-wrap", 3, "ngStyle"], ["class", "container", 4, "ngIf"], [1, "container"], [1, "text-xs", "mb-4", "text-white", "d-none", "d-lg-block"], [1, "text-white", "mb-2", 3, "ngClass"], [1, "text-white", 3, "ngClass"]], template: function B2CSubHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, B2CSubHeaderComponent_ng_container_1_Template, 3, 4, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, B2CSubHeaderComponent_ng_template_2_Template, 2, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, B2CSubHeaderComponent_ng_container_4_Template, 3, 1, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(5, B2CSubHeaderComponent_ng_template_5_Template, 3, 5, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.coverImage)("ngIfElse", _r1);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile && ctx.showSticky && ctx.scrolled);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgStyle, ɵngcc2.NgTemplateOutlet, ɵngcc3.B2CIconDirective, ɵngcc2.NgClass], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
B2CSubHeaderComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ChangeDetectorRef },
    { type: EventWrapperService }
];
B2CSubHeaderComponent.propDecorators = {
    title: [{ type: Input }],
    subtitle: [{ type: Input }],
    coverImage: [{ type: Input }],
    scrollDistance: [{ type: Input }],
    allowCustomTemplate: [{ type: Input }],
    customTemplate: [{ type: Input }],
    ngOnInit: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSubHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-subheader',
                template: "<div class=\"b2c-subheader\">\r\n  <ng-container *ngIf=\"coverImage; else defaultBackgroundTemplate\">\r\n    <div class=\"bg\" id=\"b2c-subheader-full\" [ngStyle]=\"{'background-image': 'url(' + coverImage + ')'}\">\r\n      <ng-container *ngTemplateOutlet=\"subheaderContentTemplate\"></ng-container>\r\n    </div>\r\n  </ng-container>\r\n  \r\n\r\n  <ng-template #defaultBackgroundTemplate>\r\n    <div class=\"bg\" b2c-ui-icon name=\"headerBannerIcon\" id=\"b2c-subheader-full\">\r\n      <ng-container *ngTemplateOutlet=\"subheaderContentTemplate\"></ng-container>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n\r\n<ng-container *ngIf=\"isMobile && showSticky && scrolled\">\r\n  <div class=\"w-100 text-xs text-black fixed-top text-center font-weight-bold pt-1 pb-1 shadow-sm bg-white\" style=\"z-index: 100;\">\r\n    {{ title }}\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #subheaderContentTemplate>\r\n  <div class=\"b2c-subheader-wrap\" [ngStyle]=\"{'min-height': isMobile ? '130px' : '190px'}\">\r\n    <ng-container *ngIf=\"allowCustomTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"customTemplate\"></ng-container>\r\n    </ng-container>\r\n    <div *ngIf=\"!allowCustomTemplate\" class=\"container\">\r\n      <p class=\"text-xs mb-4 text-white d-none d-lg-block\">\r\n        <ng-content></ng-content>\r\n      </p>\r\n      <h2 class=\"text-white mb-2\" [ngClass]=\"{'text-md': isMobile}\">{{ title }}</h2>\r\n      <div>\r\n        <p class=\"text-white\" [ngClass]=\"isMobile? 'text-sm' : 'text-md'\">\r\n          <ng-content select=\"p\"></ng-content>\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc1.ResponsiveService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc1.EventWrapperService }]; }, { title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], scrollDistance: [{
            type: Input
        }], allowCustomTemplate: [{
            type: Input
        }], ngOnInit: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], coverImage: [{
            type: Input
        }], customTemplate: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CSubHeaderComponent.prototype.title;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.subtitle;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.coverImage;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.scrollDistance;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.allowCustomTemplate;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.customTemplate;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.isMobile;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.subscription;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.scrollSubscription;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.scrolled;
    /** @type {?} */
    B2CSubHeaderComponent.prototype.showSticky;
    /**
     * @type {?}
     * @private
     */
    B2CSubHeaderComponent.prototype.responsiveService;
    /**
     * @type {?}
     * @private
     */
    B2CSubHeaderComponent.prototype.cdRef;
    /**
     * @type {?}
     * @private
     */
    B2CSubHeaderComponent.prototype.eventWrapper;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-subheader.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [HeaderBannerIcon];
class B2CSubHeaderModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CSubHeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CSubHeaderModule });
B2CSubHeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CSubHeaderModule_Factory(t) { return new (t || B2CSubHeaderModule)(ɵngcc0.ɵɵinject(ɵngcc3.B2CUiIconService)); }, imports: [[
            CommonModule,
            B2cUiIconModule,
            B2CNgzIconModule,
            B2CSharedResponsiveModule,
            B2CSharedEventModule
        ]] });
/** @nocollapse */
B2CSubHeaderModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CSubHeaderModule, { declarations: function () { return [B2CSubHeaderComponent]; }, imports: function () { return [CommonModule,
        B2cUiIconModule,
        B2CNgzIconModule,
        B2CSharedResponsiveModule,
        B2CSharedEventModule]; }, exports: function () { return [B2CSubHeaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSubHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CSubHeaderComponent],
                exports: [B2CSubHeaderComponent],
                imports: [
                    CommonModule,
                    B2cUiIconModule,
                    B2CNgzIconModule,
                    B2CSharedResponsiveModule,
                    B2CSharedEventModule
                ]
            }]
    }], function () { return [{ type: ɵngcc3.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CSubHeaderModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-subheader.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CSubHeaderComponent, B2CSubHeaderModule };


//# sourceMappingURL=b2c-ui-subheader.js.map